import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import AutogrowingTextarea from 'components/AutogrowingTextarea'
import { Icon } from 'shared/ui'
import { ENTER, ESCAPE } from 'constants/keys'

import {
  doTicketTitleDraftChanged,
  doStopEditingTicketTitle,
} from 'actions/app'
import { doUpdateTitle } from 'actions/tickets/fields'
import { styles } from './EditableSubject.styles'

const EditableSubjectEditingState = ({ ticket: { id: ticketId, title } }) => {
  const dispatch = useDispatch()

  const updateTitle = useCallback(
    () => {
      dispatch(doUpdateTitle(ticketId))
    },
    [dispatch, ticketId]
  )

  const stopEditingTicketTitle = useCallback(
    () => {
      dispatch(doStopEditingTicketTitle(ticketId))
    },
    [dispatch, ticketId]
  )

  const handleOnKeyDown = useCallback(
    e => {
      if (e.keyCode === ENTER) updateTitle()
      if (e.keyCode === ESCAPE) stopEditingTicketTitle()
    },
    [updateTitle, stopEditingTicketTitle]
  )

  const handleInput = useCallback(
    e => {
      const input = e.target
      dispatch(doTicketTitleDraftChanged(input.value))
    },
    [dispatch]
  )

  return (
    <div css={styles.container}>
      <AutogrowingTextarea
        css={styles.input}
        autoFocus
        defaultValue={title}
        spellCheck="false"
        autoCorrect="off"
        autoCapitalize="off"
        onBlur={stopEditingTicketTitle}
        onInput={handleInput}
        onKeyDown={handleOnKeyDown}
      />
      <Icon name="keyboard-return" size="large" onMouseDown={updateTitle} />
    </div>
  )
}

export default EditableSubjectEditingState
